<div class="header bg-primary pb-6">
  <div class="container-fluid">
    <div class="header-body">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Reports</h6>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card-body mt--7">
  <div class="row">
    <div class="col-6">
      <app-chart
        *ngIf="isData"
        [chartTitle]="title"
        [chartData]="data"
        [chartType]="type"
        [chartDataType]="dataType"
      >
      </app-chart>
    </div>
    <div class="col-6">
      <div class="card">
        <div class="card-header">
          <h6 class="surtitle">TPA Requests Report</h6>
        </div>
        <div class="card-body">
          <div class="chart">
            <canvas class="chart-canvas" id="chart-sales"> </canvas>
          </div>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="card">
        <div class="card-header">
          <h6 class="surtitle">Doctor No Shows Chart</h6>
        </div>
        <div class="card-body">
          <div class="chart">
            <canvas class="chart-canvas" id="chart-pie"> </canvas>
          </div>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="card">
        <div class="card-header">
          <h6 class="surtitle">Total Successful Consultations Report</h6>
        </div>
        <div class="card-body">
          <div class="chart">
            <canvas class="chart-canvas" id="chart-bars"> </canvas>
          </div>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="card">
        <div class="card-header">
          <h6 class="surtitle">Total Emergency Calls Report</h6>
        </div>
        <div class="card-body">
          <div class="chart">
            <canvas class="chart-canvas" id="chart-points"> </canvas>
          </div>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="card">
        <div class="card-header">
          <h6 class="surtitle">Top Products Report</h6>
        </div>
        <div class="card-body">
          <div class="chart">
            <canvas class="chart-canvas" id="chart-doughnut"> </canvas>
          </div>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="card">
        <div class="card-header">
          <h6 class="surtitle">Top Products Report #2</h6>
        </div>
        <div class="card-body">
          <div class="chart">
            <canvas class="chart-canvas" id="chart-polar"> </canvas>
          </div>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="card">
        <div class="card-header">
          <h6 class="surtitle">Total Successful Consultations Report #2</h6>
        </div>
        <div class="card-body">
          <div class="chart">
            <canvas class="chart-canvas" id="chart-horizontalbars"> </canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
